import React from 'react';
import { ChevronRight } from 'lucide-react';

const BrandStorySection = () => {
  return (
    <section id="story" className="brand-story-section">
      <div className="section-container">
        {/* Hero intro */}
        <div className="story-hero">
          <span className="section-label">NAŠA PRIČA</span>
          <h2 className="story-main-title">
            DOBRODOŠLI U SVET<br />
            <span className="title-accent">PREMIUM PUTERA</span>
          </h2>
        </div>

        {/* O nama */}
        <div className="story-block">
          <div className="story-block-content">
            <h3 className="story-block-title">O nama</h3>
            <p className="story-block-text">
              U srcu Premium Ganetovog putera leži strast prema zdravoj ishrani i iskrena 
              želja da se promoviše zdrav način života kroz prirodne i nutritivno vredne namirnice.
            </p>
            <p className="story-block-text">
              Osnivač, <strong>Dragan Gane Radenković</strong>, spojio je ljubav prema prirodi, 
              zdravim izborima i preduzetnički duh kako bi stvorio autentičan proizvod koji 
              inspiriše poverenje, kvalitet i dugoročnu vrednost.
            </p>
            <p className="story-block-text highlight">
              Naša svrha je jasna – ponuditi čist premium proizvod, bez kompromisa, 
              koji postaje deo svakodnevnih zdravih navika.
            </p>
          </div>
          <div className="story-block-image">
            <img src="/images/story1.png" alt="Premium kikiriki" className="story-image" loading="lazy" />
          </div>
        </div>

        {/* Kako smo nastali */}
        <div className="story-block reverse">
          <div className="story-block-content">
            <h3 className="story-block-title">Kako smo nastali</h3>
            <p className="story-block-text">
              Naša priča nastala je iz želje da se napravi puter koji neće biti samo ukusan, 
              već i u potpunosti prirodan.
            </p>
            <p className="story-block-text">
              Kroz pažljivo istraživanje, posvećenost detaljima i razvoj jedinstvene 
              <strong> Ganetove recepture</strong>, nastao je Premium Ganetov puter – proizvod 
              koji kombinuje najbolje iz prirode i savremeni pristup kvalitetu.
            </p>
            <p className="story-block-text">
              Od samog početka, fokus je bio na tome da svaki sastojak ima svoju svrhu, 
              a svaki proces jasan razlog postojanja.
            </p>
          </div>
          <div className="story-block-image">
            <img src="/images/story2.png" alt="Proces pravljenja putera" className="story-image" loading="lazy" />
          </div>
        </div>

        {/* Proces proizvodnje */}
        <div className="story-block">
          <div className="story-block-content">
            <h3 className="story-block-title">Proces proizvodnje</h3>
            <p className="story-block-text">
              Svaka tegla Premium Ganetovog putera nastaje od pažljivo biranih, 
              najfinijih prirodnih sastojaka.
            </p>
            <p className="story-block-text">
              Koristimo posebnu sortu <strong>brazilskog blanširanog kikirikija</strong>, 
              domaći, pravi med i ekstra devičansko maslinovo ulje.
            </p>
            <p className="story-block-text">
              Jedinstven proces proizvodnje, strogo kontrolisana temperatura i precizna 
              obrada omogućavaju da se očuvaju nutritivne vrednosti sastojaka, kao i 
              njihova prirodna, lekovita svojstva.
            </p>
            <p className="story-block-text highlight">
              Kremasta tekstura i neponovljiv ukus rezultat su pažnje posvećene svakom zrnu.
            </p>
            <div className="story-badges">
              <span className="story-badge">Bez konzervansa</span>
              <span className="story-badge">Bez dodatog šećera</span>
              <span className="story-badge">Bez glutena</span>
              <span className="story-badge">Bez veštačkih boja i aroma</span>
            </div>
          </div>
          <div className="story-block-image">
            <img src="/images/story3.png" alt="Premium kikiriki puter" className="story-image" loading="lazy" />
          </div>
        </div>

        {/* Naši standardi */}
        <div className="story-block reverse">
          <div className="story-block-content">
            <h3 className="story-block-title">Naši standardi</h3>
            <p className="story-block-text">
              <strong>Predanost, kreativnost, inovativnost</strong> i iznad svega 
              <strong> premium kvalitet</strong>, temelj su naše poslovne politike.
            </p>
            <p className="story-block-text">
              Vodimo računa o svakom detalju – od sastava proizvoda, preko procesa 
              proizvodnje, do dizajna ambalaže i jasno uočljive, atraktivne etikete.
            </p>
            <p className="story-block-text highlight">
              Od naše kompanije možete očekivati ažurnost, odgovornost i doslednost 
              na visokom nivou, jer verujemo da se poverenje gradi kvalitetom – iz dana u dan.
            </p>
          </div>
          <div className="story-block-image">
            <img src="/images/story4.png" alt="Premium kvalitet" className="story-image" loading="lazy" />
          </div>
        </div>

        {/* Gde se može pronaći */}
        <div className="story-availability">
          <h3 className="story-block-title">Gde se može pronaći Premium Ganetov puter</h3>
          <p className="story-block-text">
            Trenutno je Premium Ganetov puter dostupan putem našeg <strong>online shopa</strong>, 
            uz mogućnost ličnog preuzimanja u <strong>Novom Sadu</strong>.
          </p>
          <p className="story-block-text">
            U narednom periodu plan je proširenje dostupnosti i u HORECA sektoru, 
            delikatesnim i premium retail, pažljivo odabranim specijalizovanim 
            prodavnicama koje dele iste vrednosti kvaliteta i zdravih izbora.
          </p>
          <a href="#products" className="story-cta">
            Pogledajte naše proizvode
            <ChevronRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default BrandStorySection;
